// extracted by mini-css-extract-plugin
export default {"board":"styles_board__BaX29","foodContainer":"styles_foodContainer__u3sZ9","rest":"styles_rest__uFpHa"};